
import React, { FC } from 'react';

import { Stack } from '../../Stack';
import { List } from './List';
import { Typography } from '../../Typography';


interface TimePickerProps {
    timeSetter: React.Dispatch<React.SetStateAction<Date>>;
    selectedDate?: Date;
}


export const TimePicker: FC<TimePickerProps> = React.memo(({
    selectedDate,
    timeSetter,
}) => {
    const hours = selectedDate ? selectedDate.getHours() : undefined;
    const minutes = selectedDate ? selectedDate.getMinutes() : undefined;

    return (
        <Stack>
            <Typography
                color='grayscale.shade95'
                textAlign='center'
                py={1.5}
                px={2}
                variant='regularCaption1'
                mb={1}
            >
                {hours === undefined ? '––' : `${hours}`.padStart(2, '0')}
                :
                {minutes === undefined ? '––' : `${minutes}`.padStart(2, '0')}
            </Typography>

            <Stack
                direction='row'
                spacing={2}
            >
                <List
                    type='hours'
                    selectedDate={selectedDate}
                    valueHandler={timeSetter}
                />

                <List
                    type='minutes'
                    selectedDate={selectedDate}
                    valueHandler={timeSetter}
                />
            </Stack>
        </Stack>
    );
});
